import React, { useState, useEffect } from 'react';
import Footer from '../components/Footer';
import MainImg from "../assets/courses/gallery/mainhostel.jpg";
import hostelImg1 from "../assets/courses/gallery/hostel1.jpg";
import hostelImg2 from "../assets/courses/gallery/hostel2.jpg";
import hostelImg3 from "../assets/courses/gallery/hostel3.jpg";
import hostelImg4 from "../assets/courses/gallery/hostel4.jpg";
import GalleryImg5 from "../assets/courses/gallery/mdu5.jpg";

// Sports
import sports1 from "../assets/sport compressed/sports (1).jpg";
import sports2 from "../assets/sport compressed/sports (2).jpg";
import sports3 from "../assets/sport compressed/sports (3).jpg";
import sports4 from "../assets/sport compressed/sports (4).jpg";
import sports5 from "../assets/sport compressed/sports (5).jpg";
import sports6 from "../assets/sport compressed/sports (6).jpg";
import sports7 from "../assets/sport compressed/sports (7).jpg";
import sports8 from "../assets/sport compressed/sports (8).jpg";
import sports9 from "../assets/sport compressed/sports (9).jpg";
import sports10 from "../assets/sport compressed/sports (10).jpg";
import sports11 from "../assets/sport compressed/sports (11).jpg";
import sports12 from "../assets/sport compressed/sports (12).jpg";
import sports13 from "../assets/sport compressed/sports (13).jpg";

// Campus life
import campus13 from "../assets/campus life/campus (1).jpg";
import campus14 from "../assets/campus life/campus (2).jpg";
import campus15 from "../assets/campus life/campus (3).jpg";
import campus16 from "../assets/campus life/campus (4).jpg";
import campus17 from "../assets/campus life/campus (5).jpg";
import campus18 from "../assets/campus life/campus (6).jpg";
import campus19 from "../assets/campus life/campus (7).jpg";
import campus20 from "../assets/campus life/campus (8).jpg";
import campus21 from "../assets/campus life/campus (9).jpg";
import campus22 from "../assets/campus life/campus (10).jpg";
import campus23 from "../assets/campus life/campus (11).jpg";
import campus24 from "../assets/campus life/campus (12).jpg";
import campus25 from "../assets/campus life/campus (13).jpg";

// Fest
import fest1 from "../assets/FEST COMPRESSED/fest (1).jpg";
import fest2 from "../assets/FEST COMPRESSED/fest (2).jpg";
import fest3 from "../assets/FEST COMPRESSED/fest (3).jpg";
import fest4 from "../assets/FEST COMPRESSED/fest (4).jpg";
import fest5 from "../assets/FEST COMPRESSED/fest (5).jpg";
import fest6 from "../assets/FEST COMPRESSED/fest (6).jpg";
import fest7 from "../assets/FEST COMPRESSED/fest (7).jpg";
import fest8 from "../assets/FEST COMPRESSED/fest (8).jpg";
import fest9 from "../assets/FEST COMPRESSED/fest (9).jpg";
import fest10 from "../assets/FEST COMPRESSED/fest (10).jpg";
import fest11 from "../assets/FEST COMPRESSED/fest (11).jpg";
import fest12 from "../assets/FEST COMPRESSED/fest (12).jpg";
import fest13 from "../assets/FEST COMPRESSED/fest (13).jpg";
import fest14 from "../assets/FEST COMPRESSED/fest (14).jpg";
import fest15 from "../assets/FEST COMPRESSED/fest (15).jpg";
import fest16 from "../assets/FEST COMPRESSED/fest (16).jpg";
import fest17 from "../assets/FEST COMPRESSED/fest (17).jpg";
import fest18 from "../assets/FEST COMPRESSED/fest (18).jpg";
import fest19 from "../assets/FEST COMPRESSED/fest (19).jpg";
import fest20 from "../assets/FEST COMPRESSED/fest (20).jpg";
import fest21 from "../assets/FEST COMPRESSED/fest (21).jpg";
import fest22 from "../assets/FEST COMPRESSED/fest (22).jpg";
import fest23 from "../assets/FEST COMPRESSED/fest (23).jpg";
import fest24 from "../assets/FEST COMPRESSED/fest (24).jpg";
import fest25 from "../assets/FEST COMPRESSED/fest (25).jpg";
import fest26 from "../assets/FEST COMPRESSED/fest (26).jpg";
import fest27 from "../assets/FEST COMPRESSED/fest (27).jpg";
import fest28 from "../assets/FEST COMPRESSED/fest (28).jpg";
import fest29 from "../assets/FEST COMPRESSED/fest (29).jpg";
import fest30 from "../assets/FEST COMPRESSED/fest (30).jpg";

// hostel
import hostelImg5 from "../assets/Hostel/hostel (1).jpg";
import hostelImg6 from "../assets/Hostel/hostel (2).jpg";
import hostelImg7 from "../assets/Hostel/hostel (3).jpg";
import hostelImg8 from "../assets/Hostel/hostel (4).jpg";
import hostelImg9 from "../assets/Hostel/hostel (5).jpg";
import hostelImg10 from "../assets/Hostel/hostel (6).jpg";
import hostelImg11 from "../assets/Hostel/hostel (7).jpg";
import hostelImg12 from "../assets/Hostel/hostel (8).jpg";

// Organized gallery data by categories
const galleryCategories = {
  campus: [
    { id: 1, image: campus13, title: "Campus View", highlighted: false },
    { id: 2, image: campus14, title: "Campus View", highlighted: true },
    { id: 3, image: campus15, title: "Campus View", highlighted: false },
    { id: 4, image: campus16, title: "Campus View", highlighted: false },
    { id: 5, image: campus17, title: "Campus View", highlighted: true },
    { id: 6, image: campus18, title: "Campus View", highlighted: false },
    { id: 7, image: campus19, title: "Campus View", highlighted: false },
    { id: 8, image: campus20, title: "Campus View", highlighted: false },
    { id: 9, image: campus21, title: "Campus View", highlighted: true },
    { id: 10, image: campus22, title: "Campus View", highlighted: false },
    { id: 11, image: campus23, title: "Campus View", highlighted: false },
    { id: 12, image: campus24, title: "Campus View", highlighted: false },
    { id: 13, image: campus25, title: "Campus View", highlighted: false },
  ],
  hostel: [
    { id: 1, image: hostelImg1, title: "Modern Hostel Facilities", highlighted: true },
    { id: 2, image: hostelImg2, title: "Student Accommodation", highlighted: false },
    { id: 3, image: hostelImg3, title: "Hostel Common Areas", highlighted: false },
    { id: 4, image: hostelImg4, title: "Campus Housing", highlighted: true },
    { id: 5, image: hostelImg5, title: "Hostel Common Areas", highlighted: false },
    { id: 6, image: hostelImg6, title: "Hostel Common Areas", highlighted: false },
    { id: 7, image: hostelImg7, title: "Hostel Common Areas", highlighted: false },
    { id: 8, image: hostelImg8, title: "Hostel Common Areas", highlighted: false },
    { id: 9, image: hostelImg9, title: "Hostel Common Areas", highlighted: true },
    { id: 10, image: hostelImg10, title: "Hostel Common Areas", highlighted: false },
    { id: 11, image: hostelImg11, title: "Hostel Common Areas", highlighted: false },
    { id: 12, image: hostelImg12, title: "Hostel Common Areas", highlighted: false },
  ],
  sports: [
    { id: 1, image: sports1, title: "Karate Court", highlighted: true },
    { id: 2, image: sports2, title: "Kabaddi", highlighted: false },
    { id: 3, image: sports3, title: "Cricket", highlighted: true },
    { id: 4, image: sports4, title: "Yoga", highlighted: false },
    { id: 5, image: sports5, title: "Yoga", highlighted: false },
    { id: 6, image: sports6, title: "Yoga", highlighted: false },
    { id: 7, image: sports7, title: "Chess", highlighted: true },
    { id: 8, image: sports8, title: "Gym", highlighted: false },
    { id: 9, image: sports9, title: "Volleyball", highlighted: false },
    { id: 10, image: sports10, title: "Yoga", highlighted: false },
    { id: 11, image: sports11, title: "Billiards", highlighted: true },
    { id: 12, image: sports12, title: "Gym", highlighted: false },
    { id: 13, image: sports13, title: "Gym", highlighted: false },
    { id: 14, image: GalleryImg5, title: "Boxing", highlighted: true },
  ],
  fest: [
    { id: 4, image: fest1, title: "Cultural Fest", highlighted: true },
    { id: 5, image: fest2, title: "Cultural Fest", highlighted: false },
    { id: 6, image: fest3, title: "Cultural Fest", highlighted: false },
    { id: 7, image: fest4, title: "Cultural Fest", highlighted: true },
    { id: 8, image: fest5, title: "Cultural Fest", highlighted: false },
    { id: 9, image: fest6, title: "Cultural Fest", highlighted: false },
    { id: 10, image: fest7, title: "Cultural Fest", highlighted: true },
    { id: 11, image: fest8, title: "Cultural Fest", highlighted: false },
    { id: 12, image: fest9, title: "Cultural Fest", highlighted: false },
    { id: 13, image: fest10, title: "Cultural Fest", highlighted: true },
    { id: 14, image: fest11, title: "Cultural Fest", highlighted: false },
    { id: 15, image: fest12, title: "Cultural Fest", highlighted: false },
    { id: 16, image: fest13, title: "Cultural Fest", highlighted: true },
    { id: 17, image: fest14, title: "Cultural Fest", highlighted: false },
    { id: 18, image: fest15, title: "Cultural Fest", highlighted: false },
    { id: 19, image: fest16, title: "Cultural Fest", highlighted: true },
    { id: 20, image: fest17, title: "Cultural Fest", highlighted: false },
    { id: 21, image: fest18, title: "Cultural Fest", highlighted: false },
    { id: 22, image: fest19, title: "Cultural Fest", highlighted: true },
    { id: 23, image: fest20, title: "Cultural Fest", highlighted: false },
    { id: 24, image: fest21, title: "Cultural Fest", highlighted: false },
    { id: 25, image: fest22, title: "Cultural Fest", highlighted: true },
    { id: 26, image: fest23, title: "Cultural Fest", highlighted: false },
    { id: 27, image: fest24, title: "Cultural Fest", highlighted: false },
    { id: 28, image: fest25, title: "Cultural Fest", highlighted: true },
    { id: 29, image: fest26, title: "Cultural Fest", highlighted: false },
    { id: 30, image: fest27, title: "Cultural Fest", highlighted: false },
    { id: 31, image: fest28, title: "Cultural Fest", highlighted: true },
    { id: 32, image: fest29, title: "Cultural Fest", highlighted: false },
    { id: 33, image: fest30, title: "Cultural Fest", highlighted: false },
  ],
};

// Category descriptions
const categoryDescriptions = {
  campus: {
    intro: "Our sprawling campus is a vibrant hub of learning and innovation, blending modern architecture with serene green spaces.",
    paragraph: "Designed to inspire, our campus offers state-of-the-art facilities, including advanced research labs, expansive libraries, and collaborative study areas. Students thrive in an environment that fosters creativity, critical thinking, and community engagement, making every day an opportunity for growth and discovery."
  },
  hostel: {
    intro: "Experience comfortable and modern living in our thoughtfully designed hostels, tailored to support student success.",
    paragraph: "Our hostels provide a home away from home, with spacious rooms, high-speed internet, and vibrant common areas for socializing and relaxation. With 24/7 security and dedicated staff, we ensure a safe and nurturing environment where students can focus on their academic and personal growth."
  },
  sports: {
    intro: "Unleash your potential with our world-class sports facilities, fostering fitness, teamwork, and competitive spirit.",
    paragraph: "From cricket fields to state-of-the-art gyms, our campus offers diverse athletic opportunities for every student. Our sports programs, led by expert coaches, encourage physical excellence and camaraderie, with regular tournaments and wellness activities that promote a balanced lifestyle."
  },
  fest: {
    intro: "Celebrate creativity and culture at our vibrant festivals, where students shine through performances and innovation.",
    paragraph: "Our annual cultural and tech fests are a highlight of campus life, showcasing talent in music, dance, drama, and technology. These events bring the community together, fostering lifelong memories and connections while highlighting the diverse talents of our student body."
  },
};

// Category icons
const categoryIcons = {
  campus: (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    </svg>
  ),
  hostel: (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
    </svg>
  ),
  sports: (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  ),
  fest: (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
    </svg>
  ),
};

const CampusLife = () => {
  const [activeCategory, setActiveCategory] = useState('hostel');
  const [selectedImage, setSelectedImage] = useState(null);
  const [visibleItems, setVisibleItems] = useState(8);
  const [isLoading, setIsLoading] = useState(false);

  // For parallax effect
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleCategoryChange = (category) => {
    setActiveCategory(category);
    setVisibleItems(8); // Reset visible items when changing category
    window.scrollTo({
      top: document.getElementById('gallery-section').offsetTop - 100,
      behavior: 'smooth'
    });
  };

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden'; // Prevent scrolling when lightbox is open
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto'; // Enable scrolling again
  };

  const loadMoreItems = () => {
    setIsLoading(true);
    // Simulate loading delay
    setTimeout(() => {
      setVisibleItems(prevCount => Math.min(prevCount + 8, galleryCategories[activeCategory].length));
      setIsLoading(false);
    }, 600);
  };

  // Keyboard navigation for lightbox
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;
      
      if (e.key === 'Escape') {
        closeLightbox();
      } else if (e.key === 'ArrowRight') {
        const currentIndex = galleryCategories[activeCategory].findIndex(item => item.id === selectedImage.id);
        const nextIndex = (currentIndex + 1) % galleryCategories[activeCategory].length;
        setSelectedImage(galleryCategories[activeCategory][nextIndex]);
      } else if (e.key === 'ArrowLeft') {
        const currentIndex = galleryCategories[activeCategory].findIndex(item => item.id === selectedImage.id);
        const prevIndex = (currentIndex - 1 + galleryCategories[activeCategory].length) % galleryCategories[activeCategory].length;
        setSelectedImage(galleryCategories[activeCategory][prevIndex]);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedImage, activeCategory]);

  // Navigation controls for lightbox
  const navigateToNextImage = (e) => {
    e.stopPropagation();
    const currentIndex = galleryCategories[activeCategory].findIndex(item => item.id === selectedImage.id);
    const nextIndex = (currentIndex + 1) % galleryCategories[activeCategory].length;
    setSelectedImage(galleryCategories[activeCategory][nextIndex]);
  };

  const navigateToPrevImage = (e) => {
    e.stopPropagation();
    const currentIndex = galleryCategories[activeCategory].findIndex(item => item.id === selectedImage.id);
    const prevIndex = (currentIndex - 1 + galleryCategories[activeCategory].length) % galleryCategories[activeCategory].length;
    setSelectedImage(galleryCategories[activeCategory][prevIndex]);
  };

  return (
    <div className="w-full relative bg-gray-50">
      {/* Hero Image with Parallax Effect and Overlay Text */}
      <div className="relative h-[60vh] md:h-[80vh] overflow-hidden">
        <div 
          className="absolute inset-0 w-full h-full" 
          style={{ 
            backgroundImage: `url(${MainImg})`, 
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            transform: `translateY(${scrollY * 0.4}px)`,
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80 flex flex-col items-center justify-center px-4">
          <h1 className="text-5xl md:text-7xl font-black text-white text-center tracking-tight animate-fade-in mb-4 drop-shadow-lg">
            Campus Life
          </h1>
          <div className="h-1 w-24 bg-[#0e4d38] rounded-full mb-6"></div>
          <p className="text-lg md:text-xl text-white text-center max-w-2xl animate-fade-in opacity-90">
            Discover the vibrant community, state-of-the-art facilities, and unforgettable experiences that await you.
          </p>
        </div>
        
        {/* Scroll down indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <svg className="w-8 h-8 text-white" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
            <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
          </svg>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-11/12 md:w-10/12 mx-auto mt-16 flex flex-col gap-12 relative z-10">
        {/* Fest Registration Notice - Always visible */}
        <div className="animate-bounce-slow bg-[#0e4d38]/10 rounded-lg p-6 border-l-4 border-[#0e4d38] mb-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#0e4d38]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              <div>
                <h3 className="text-xl font-bold text-[#0e4d38]">Fest Registration Now Open!</h3>
                <p className="text-gray-600">Don't miss out on the biggest cultural event of the year.</p>
              </div>
            </div>
            <a
              href="https://forms.gle/1J5QKNoTSCKZd82h8"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#0e4d38] text-white rounded-lg font-semibold 
                transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Register Now
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </a>
          </div>
        </div>

        {/* Introductory Section with Modern Design */}
        <div className="text-center relative">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6 animate-slide-up mt-12">
            A <span className="text-[#0e4d38]">Vibrant</span> University Experience
          </h2>
          <div className="max-w-3xl mx-auto">
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-8">
              At our university, campus life is a dynamic blend of academic excellence, cultural diversity, and personal growth. Explore our world-class facilities, engage in exciting activities, and join a community that inspires greatness.
            </p>

            {/* Fest Registration Notice - Bottom */}
            <div className="mt-8 mb-4 bg-gradient-to-r from-[#0e4d38]/5 via-[#0e4d38]/10 to-[#0e4d38]/5 rounded-xl p-6">
              <div className="flex flex-col items-center gap-4">
                <div className="text-center">
                  <h3 className="text-xl font-bold text-[#0e4d38] mb-2">Ready to Join the Fest?</h3>
                  <p className="text-gray-600 max-w-2xl">Be part of the most anticipated cultural celebration. Register now to showcase your talents and create unforgettable memories!</p>
                </div>
                <a
                  href="https://forms.gle/1J5QKNoTSCKZd82h8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-8 py-3 bg-[#0e4d38] text-white rounded-full font-semibold 
                    transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl
                    animate-pulse hover:animate-none"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                  Register for Fest
                </a>
              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-6 mt-8">
              {Object.keys(galleryCategories).map((category) => (
                <div 
                  key={category}
                  className="flex flex-col items-center gap-2 group cursor-pointer" 
                  onClick={() => handleCategoryChange(category)}
                >
                  <div className={`w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110 ${
                    activeCategory === category
                      ? 'bg-[#0e4d38] text-white shadow-lg'
                      : 'bg-white text-[#0e4d38] shadow border border-gray-200 group-hover:bg-gray-100'
                  }`}>
                    {categoryIcons[category]}
                  </div>
                  <span className={`font-medium transition-colors ${
                    activeCategory === category ? 'text-[#0e4d38]' : 'text-gray-600'
                  }`}>
                    {category.charAt(0).toUpperCase() + category.slice(1)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="flex items-center justify-center">
          <div className="h-px w-full max-w-lg bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
        </div>

        {/* Category Description */}
        <div id="gallery-section" className="text-center mb-6 animate-fade-in">
          <div className="inline-block px-4 py-1 rounded-full bg-[#0e4d38]/10 text-[#0e4d38] font-medium text-sm mb-4">
            Explore {activeCategory.charAt(0).toUpperCase() + activeCategory.slice(1)}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            {activeCategory.charAt(0).toUpperCase() + activeCategory.slice(1)} <span className="text-[#0e4d38]">Life</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto mb-4 italic">
            "{categoryDescriptions[activeCategory].intro}"
          </p>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {categoryDescriptions[activeCategory].paragraph}
          </p>
          
          {/* Add Fest Registration button only when fest category is active */}
          {activeCategory === 'fest' && (
            <div className="mt-8">
              <a
                href="https://forms.gle/1J5QKNoTSCKZd82h8"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-8 py-4 bg-[#0e4d38] text-white rounded-lg font-semibold 
                  transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl
                  animate-pulse hover:animate-none"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                Register for Fest
              </a>
            </div>
          )}
        </div>

        {/* Modern Gallery Grid with Masonry Layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {galleryCategories[activeCategory].slice(0, visibleItems).map((item, index) => (
            <div
              key={item.id}
              className={`relative overflow-hidden rounded-lg shadow-md transition-all duration-500 hover:shadow-xl transform hover:-translate-y-1 group cursor-pointer ${
                index % 5 === 0 ? 'md:col-span-2 md:row-span-2' : ''
              }`}
              onClick={() => openLightbox(item)}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={item.image}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  alt={item.title}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                  <h3 className="text-white font-semibold text-lg md:text-xl mb-1">{item.title}</h3>
                  <div className="w-8 h-1 bg-[#0e4d38] rounded-full transform origin-left scale-0 group-hover:scale-100 transition-transform duration-500"></div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        {visibleItems < galleryCategories[activeCategory].length && (
          <div className="flex justify-center mt-8">
            <button
              onClick={loadMoreItems}
              disabled={isLoading}
              className="px-8 py-3 flex items-center gap-2 bg-white border-2 border-[#0e4d38] text-[#0e4d38] rounded-full hover:bg-[#0e4d38] hover:text-white transition-all duration-300 font-medium shadow-md hover:shadow-lg disabled:opacity-50"
            >
              {isLoading ? (
                <>
                  <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Loading...
                </>
              ) : (
                <>
                  Load More
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                  </svg>
                </>
              )}
            </button>
          </div>
        )}

        {/* New Section Above Footer */}
        <div className="relative mt-16 mb-20 py-16 bg-[#0e4d38] rounded-2xl overflow-hidden">
          {/* Abstract decoration */}
          <div className="absolute top-0 left-0 w-full h-full opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-white transform translate-x-1/3 -translate-y-1/3"></div>
            <div className="absolute bottom-0 left-0 w-96 h-96 rounded-full bg-white transform -translate-x-1/3 translate-y-1/3"></div>
          </div>
          
          <div className="relative z-10 text-center px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Join Our Vibrant Community
            </h2>
            <p className="text-lg text-white/90 max-w-3xl mx-auto mb-10 leading-relaxed">
            Experience a transformative journey where academic excellence meets personal growth. Our campus life provides endless opportunities to discover your passions, forge lifelong friendships, and build the foundation for your future success.
            </p>
            
            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-12">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 transform transition-transform hover:scale-105">
                <div className="text-4xl font-bold text-white mb-2">95%</div>
                <div className="text-white/80">Student Satisfaction</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 transform transition-transform hover:scale-105">
                <div className="text-4xl font-bold text-white mb-2">50+</div>
                <div className="text-white/80">Student Organizations</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 transform transition-transform hover:scale-105">
                <div className="text-4xl font-bold text-white mb-2">100%</div>
                <div className="text-white/80">WiFi Coverage</div>
              </div>
            </div>
            
            {/* CTA */}
            {/* <div className="flex flex-wrap justify-center gap-4">
              <button className="px-8 py-3 bg-white text-[#0e4d38] rounded-full font-semibold hover:bg-gray-100 transition-colors shadow-lg">
                Schedule a Visit
              </button>
              <button className="px-8 py-3 bg-transparent border-2 border-white text-white rounded-full font-semibold hover:bg-white/10 transition-colors">
                Apply Now
              </button>
            </div> */}
          </div>
        </div>
      </div>

      {/* Advanced Lightbox with Navigation Controls */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-95 z-50 flex items-center justify-center p-4 animate-fade-in"
          onClick={closeLightbox}
        >
          <div className="relative max-w-6xl w-full h-[85vh] flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
            {/* Previous button */}
            <button
              className="absolute left-4 md:left-8 z-10 text-white bg-black/40 hover:bg-black/60 rounded-full w-10 h-10 md:w-12 md:h-12 flex items-center justify-center transition-all duration-300"
              onClick={navigateToPrevImage}
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            
            {/* Image container with animation */}
            <div className="relative max-h-full overflow-hidden rounded-lg shadow-2xl">
              <img
                src={selectedImage.image}
                className="max-w-full max-h-[75vh] object-contain"
                alt={selectedImage.title}
              />
              
              {/* Image info panel */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-6 text-white">
                <h3 className="text-xl md:text-2xl font-bold">{selectedImage.title}</h3>
                <p className="text-sm md:text-base opacity-80 mt-1">
                  {activeCategory.charAt(0).toUpperCase() + activeCategory.slice(1)} • {galleryCategories[activeCategory].findIndex(item => item.id === selectedImage.id) + 1} of {galleryCategories[activeCategory].length}
                </p>
              </div>
            </div>
            
            {/* Next button */}
            <button
              className="absolute right-4 md:right-8 z-10 text-white bg-black/40 hover:bg-black/60 rounded-full w-10 h-10 md:w-12 md:h-12 flex items-center justify-center transition-all duration-300"
              onClick={navigateToNextImage}
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
            
            {/* Close button */}
            <button
              className="absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 rounded-full w-10 h-10 flex items-center justify-center text-2xl transition-all"
              onClick={closeLightbox}
            >
              ×
            </button>
            
            {/* Keyboard navigation hint */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black/30 backdrop-blur-sm px-4 py-2 rounded-full text-white/70 text-sm hidden md:flex items-center gap-2">
              <span>Use</span>
              <kbd className="px-2 py-1 bg-white/20 rounded">←</kbd>
              <span>and</span>
              <kbd className="px-2 py-1 bg-white/20 rounded">→</kbd>
              <span>to navigate</span>
            </div>
          </div>
        </div>
      )}

      {/* Custom floating scroll-to-top button */}
      {scrollY > 500 && (
        <button 
          onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
          className="fixed bottom-6 right-6 z-40 bg-[#0e4d38] text-white w-12 h-12 rounded-full shadow-lg flex items-center justify-center hover:bg-[#0c3d2d] transition-all animate-slide-up"
        >
          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg>
        </button>
      )}

      {/* Custom styles */}
      <style jsx>{`
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes slide-up {
          from { transform: translateY(30px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        
        .animate-fade-in {
          animation: fade-in 0.8s ease-out forwards;
        }
        
        .animate-slide-up {
          animation: slide-up 0.8s ease-out forwards;
        }
        
        @media (max-width: 768px) {
          .masonry-grid {
            column-count: 2;
          }
        }
        
        @media (min-width: 769px) {
          .masonry-grid {
            column-count: 3;
          }
        }
        
        @media (min-width: 1024px) {
          .masonry-grid {
            column-count: 4;
          }
        }
      `}</style>

      <Footer />
    </div>
  );
};

export default CampusLife;